import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { Box, FormControl, FormGroup, Grid, Typography } from '@material-ui/core';
import { Link, ListItem } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Badge from '@material-ui/core/Badge';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useHistory } from 'react-router';
import DataService from '../../../../../src/Service';

const useStyles: any = makeStyles((theme) => ({
    root: {
        borderBottom: '1px #ddd solid',
        marginBottom: '10px'
    },
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
    icon: {
        cursor: "pointer",
        width: "22px !important",
        height: "22px !important"
    },
    image: {
        width: 40,
        height: 40,
        backgroundColor: "#ddd",
        borderRadius: '50%'
    },
}));

interface IProps {
    action: string,
    handleClose: Function,
    notificationList: any,
    setRefreshNotification: any
};

interface INotificationData {
    date: any,
    updated_at: any,
    header: string,
    message: string,
    image_url: string
    id: number
};

const NotificationDrawer: React.FC<IProps> = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const { handleClose, action, notificationList, setRefreshNotification } = props;

    const [drawerFlag, setDrawerFlag] = useState<any>({ drawerFlag: false });

    const toggleDrawer = (anchor: any, open: any) => (event: any) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerFlag(open);
        handleClose()
    };

    const redirection = () => {
        history.location.pathname == "/admin/crf" ? handleClose() : history.push("/admin/crf")
    }

    const handleClickNotification = (id: number) => {
        const param = {
            read: "true"
        }

        DataService.updateData(param, id as any, "update_notification").then((response) => {
            if (response?.success) {
                setRefreshNotification((oldValue: boolean) => !oldValue)
            }
        })
    }

    const list = (anchor: string) => (
        <Box m={3} pt={8} style={{ width: '405px' }}>
            <Grid container xs={12} direction="row" justify='space-between' >
                <Typography variant="h1"><Box mb={3} fontWeight="bold">Notifications</Box></Typography>
                <Link color="inherit" className={classes.icon} onClick={() => { handleClose() }}>
                    <CloseIcon fontSize="small" />
                </Link>
            </Grid>
            <div>
                <Typography variant="subtitle1" display="block" gutterBottom>
                    <Box>Today</Box>
                </Typography>
                <FormGroup>
                    {notificationList?.unread_notifications?.length ? <>
                        {notificationList?.unread_notifications?.map((option: INotificationData, index: number) => {
                            return <ListItem key={index} onClick={() => handleClickNotification(option?.id)}>
                                <Grid container className={classes.root} spacing={2}>
                                    <Grid item xs={2} md={2}>
                                        <Badge style={{ paddingTop: "6px" }} color="secondary" anchorOrigin={{ vertical: 'top', horizontal: 'right' }} badgeContent=" " variant="dot">
                                            <img src={option.image_url || "../../../../assets/images/brain.png"} className={classes.image} alt="" />
                                        </Badge>
                                    </Grid>
                                    <Grid item xs={10} md={10}>
                                        <Box style={{ width: '100%' }} onClick={redirection}>
                                            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                                                <Box>{option?.header}</Box>
                                            </Typography>
                                            <Typography variant="h2" display="block" gutterBottom>
                                                <Box>{option?.message}</Box>
                                            </Typography>
                                            <Typography variant="h2">
                                                <Box>{option?.date}</Box>
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>

                            </ListItem>
                        })}</>
                        : <>
                            <ListItem>
                                <Grid container className={classes.root} spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography variant="h6">
                                            <Box>{'No Notifications found.'}</Box>
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </ListItem>
                        </>}

                </FormGroup>
            </div>
        </Box >
    );

    return (
        <>
            <div>
                <React.Fragment>
                    <SwipeableDrawer
                        anchor={'right'}
                        style={{ width: '405px' }}
                        open={drawerFlag}
                        onClose={toggleDrawer('drawerFlag', false)}
                        onOpen={toggleDrawer('drawerFlag', true)}
                    >
                        {list('right')}
                    </SwipeableDrawer>
                </React.Fragment>
            </div>
        </>
    );
}

export default NotificationDrawer;